export default function getHotfixReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_HOTFIX_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_HOTFIX_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_HOTFIX_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}